import { apiClient } from "@/api"
import { format, parseISO } from "date-fns"
import { useCallback, useEffect, useState } from "react"

export const useFetchLessons = ({ scheduleId }) => {
  const [assignments, setAssignments] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchAssignments = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      if (scheduleId) {
        const response = await apiClient.get(`/api/v2/schedules/${scheduleId}/assignments`)
        setAssignments(response?.data || [])
      }
      setLoading(false)
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }, [scheduleId])

  useEffect(() => {
    fetchAssignments()
  }, [fetchAssignments])

  return {
    lessons: assignments?.map(assignment => ({
      ...assignment,
      started_on: format(parseISO(assignment.started_on), "MMMM dd, yyyy"),
    })),
    loading,
    error,
  }
}

export default useFetchLessons
